import { ShoppingBag } from "lucide-react";

const CheckoutHeader = () => (
  <div className="bg-[#111111] border-b border-white/[0.08] sticky top-0 z-40">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#FF6B35]/10 border border-[#FF6B35]/20 rounded-xl flex items-center justify-center">
          <ShoppingBag className="h-5 w-5 text-[#FF6B35]" />
        </div>
        <div>
          <h1 className="text-lg sm:text-xl font-bold text-white">Secure Checkout</h1>
          <p className="text-xs text-gray-500">Complete your vehicle service booking</p>
        </div>
      </div>
    </div>
  </div>
);

export default CheckoutHeader;
